import React, { useEffect, useState } from 'react';
import { executionOperationsService } from '../../services/executionOperationsService';

export const OperationsHistoryPage: React.FC = () => {
  const [history, setHistory] = useState<unknown[]>([]);
  const [deadLetters, setDeadLetters] = useState<unknown[]>([]);

  useEffect(() => {
    void (async () => {
      const [h, d] = await Promise.all([
        executionOperationsService.getExecutionHistory(100),
        executionOperationsService.getDeadLetters(),
      ]);
      setHistory(h.data || []);
      setDeadLetters(d.data || []);
    })();
  }, []);

  return (
    <div className="space-y-4">
      <Panel title="Execution history" data={history} />
      <Panel title="Dead letter queue" data={deadLetters} />
    </div>
  );
};

const Panel: React.FC<{ title: string; data: unknown[] }> = ({ title, data }) => (
  <div className="rounded-xl border border-enterprise-200 bg-white p-4 shadow-sm">
    <h2 className="mb-3 font-semibold text-enterprise-900">{title}</h2>
    <pre className="max-h-96 overflow-auto rounded bg-enterprise-50 p-3 text-xs">{JSON.stringify(data, null, 2)}</pre>
  </div>
);
